/** 홍보 영상 검수 화면 (pages/todaymall/promoVideo). */
export default {
  'pages.promoVideo.title': "Promo video review",
  'pages.promoVideo.hint': "Watch the whole video and check that the product's shape, colours and logo match the photos before approving. Only approved videos are attached to shares.",
  'pages.promoVideo.health.ok': "Video server OK",
  'pages.promoVideo.health.degraded': "Video server degraded",
  'pages.promoVideo.health.off': "Feature off",
  'pages.promoVideo.health.queue': "{n} queued",
  'pages.promoVideo.tab.review': "To review",
  'pages.promoVideo.tab.approved': "Approved",
  'pages.promoVideo.tab.making': "In progress",
  'pages.promoVideo.tab.failed': "Failed",
  'pages.promoVideo.tab.rejected': "Rejected",
  'pages.promoVideo.tab.all': "All",
  'pages.promoVideo.status.queued': "Queued",
  'pages.promoVideo.status.generating': "Generating",
  'pages.promoVideo.status.review': "To review",
  'pages.promoVideo.status.approved': "Approved",
  'pages.promoVideo.status.rejected': "Rejected",
  'pages.promoVideo.status.failed': "Failed",
  'pages.promoVideo.col.poster': "Video",
  'pages.promoVideo.col.product': "Product",
  'pages.promoVideo.col.source': "Source",
  'pages.promoVideo.col.status': "Status",
  'pages.promoVideo.col.price': "Price",
  'pages.promoVideo.col.requests': "Share requests",
  'pages.promoVideo.col.updated': "Updated",
  'pages.promoVideo.action.view': "View",
  'pages.promoVideo.action.approve': "Approve",
  'pages.promoVideo.action.reject': "Reject",
  'pages.promoVideo.action.regenerate': "Pick photos & regenerate",
  'pages.promoVideo.action.recompose': "Re-render text only",
  'pages.promoVideo.action.request': "Make for a product",
  'pages.promoVideo.action.openProduct': "Product page",
  'pages.promoVideo.action.search': "Search",
  'pages.promoVideo.action.refresh': "Refresh",
  'pages.promoVideo.reject.reason': "Reason (optional)",
  'pages.promoVideo.detail.title': "Product name in the video",
  'pages.promoVideo.detail.captions': "Captions (one per shot)",
  'pages.promoVideo.detail.price': "Sale price (KRW)",
  'pages.promoVideo.detail.tagPrice': "List price (KRW, for the discount)",
  'pages.promoVideo.detail.photos': "Pick the photos for AI shots (leave out infographics and spec sheets)",
  'pages.promoVideo.detail.photoAi': "AI",
  'pages.promoVideo.detail.photoInfographic': "Infographic",
  'pages.promoVideo.detail.shots': "Shots used",
  'pages.promoVideo.detail.shotClip': "AI shot",
  'pages.promoVideo.detail.shotImage': "Photo zoom",
  'pages.promoVideo.detail.qc': "Similarity",
  'pages.promoVideo.detail.music': "Music",
  'pages.promoVideo.detail.lastError': "Error",
  'pages.promoVideo.detail.progress': "Progress",
  'pages.promoVideo.detail.noVideo': "No video yet.",
  'pages.promoVideo.detail.recomposeHint': "Re-rendering text does not use the GPU (~10s). If the shots are wrong, pick photos and regenerate (~3 min).",
  'pages.promoVideo.msg.approved': "Approved. Shares now carry the video link.",
  'pages.promoVideo.msg.rejected': "Rejected.",
  'pages.promoVideo.msg.regenerating': "Regenerating — about 3 minutes.",
  'pages.promoVideo.msg.recomposed': "Text re-rendered.",
  'pages.promoVideo.msg.requested': "Requested.",
  'pages.promoVideo.msg.pickPhoto': "Pick at least one photo.",
  'pages.promoVideo.form.source': "Source",
  'pages.promoVideo.form.productId': "Product ID",
  'pages.promoVideo.form.search': "Name or ID",
  'pages.promoVideo.form.link': "Product link",
  'pages.promoVideo.form.linkPlaceholder': "https://detail.1688.com/offer/….html",
  'pages.promoVideo.form.linkHelp': "Paste a 1688, Taobao (Tmall) or VVIC product URL, or a TodayMall product or share URL. Open short links first and paste the full address.",
  'pages.promoVideo.form.linkRequired': "Paste a product link.",
};
